<div class="utils-buttons" [class.light-theme]="theme === 'LIGHT'" [class.dark-theme]="theme === 'DARK'">
  <button
    type="button"
    class="text-button change-font-size-button"
    (click)="changeFontSize()"
    [attr.aria-label]="'COMMON.LAYOUT.CHANGE_FONT_SIZE' | translate">
    aA
  </button>

  <div class="lang-label">{{ 'COMMON.LANGUAGE.PICK_LANGUAGE' | translate }}:</div>

  @if (availableLanguages?.length && currentUserLang?.key) {
    @for (lang of availableLanguages; track lang; let langIndex = $index) {
      <button
        type="button"
        class="text-button"
        [class.active]="currentUserLang.key === lang.key"
        (click)="changeLangTo(lang)"
        [attr.aria-label]="'COMMON.LANGUAGE.' + lang.key.toUpperCase() | translate">
        {{ 'COMMON.LANGUAGE.' + lang.key.toUpperCase() + '_SHORT' | translate }}
      </button>
    }
  }
</div>
